'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDaysForCalendar = undefined;

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

exports.fromPeriodToMomentRange = fromPeriodToMomentRange;
exports.hasMonth = hasMonth;
exports.hasDay = hasDay;
exports.hasWeek = hasWeek;
exports.hasQuarter = hasQuarter;
exports.hasHalfYear = hasHalfYear;
exports.hasRollingQuarter = hasRollingQuarter;
exports.hasYear = hasYear;
exports.fromDateToMomentRange = fromDateToMomentRange;
exports.isInPeriod = isInPeriod;
exports.isInRange = isInRange;
exports.fromPeriodToDisplayString = fromPeriodToDisplayString;
exports.quarterIsStartOfHalfYear = quarterIsStartOfHalfYear;
exports.quarterIsEndOfHalfYear = quarterIsEndOfHalfYear;

var _some = require('lodash/some');

var _some2 = _interopRequireDefault(_some);

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _constants = require('./constants');

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var QUARTER_MONTHS = _constants2.default.QUARTER_MONTHS,
    HALFYEAR_MONTHS = _constants2.default.HALFYEAR_MONTHS,
    QUARTERS = _constants2.default.QUARTERS,
    TOTAL_MONTHS = _constants2.default.TOTAL_MONTHS; // converts a period to a moment range

function fromPeriodToMomentRange(_ref) {
  var type = _ref.type,
      date = _ref.date; // the date range the period spans, [)

  var beginDate = (0, _momentTimezone2.default)(date);
  var endDate = void 0;

  if (type === 'month') {
    endDate = beginDate.clone().add(1, 'months');
  } else if (type === 'quarter' || type === 'rollingQuarter') {
    endDate = beginDate.clone().add(3, 'months');
  } else if (type === 'halfyear') {
    endDate = beginDate.clone().add(6, 'months');
  } else if (type === 'year') {
    endDate = beginDate.clone().add(1, 'years');
  }

  return [beginDate, endDate];
} // checks if month can be selected within date range


function hasMonth(startDate, endDate, month, year) {
  var targetMonth = (0, _momentTimezone2.default)({
    year: year,
    month: month,
    day: 2
  }); // inclusive

  return targetMonth.isBetween(startDate, endDate, null, '[]');
} // checks if day can be selected within date range
// if you have access to the month, then you have access to the day


function hasDay(startDate, endDate, month, year) {
  return hasMonth(startDate, endDate, month, year);
} // checks if user has access to week and if user should be able to select week


function hasWeek(startDate, endDate, requestDate) {
  return requestDate.isBetween(startDate.clone().startOf('isoWeek'), endDate, null, '[]');
} // checks if quarter can be selected within date range


function hasQuarter(startDate, endDate, quarter, year) {
  var quarterMonths = QUARTERS[quarter].months;
  return (0, _some2.default)(quarterMonths, function (month) {
    return hasMonth(startDate, endDate, month.number, year);
  });
} // checks if half year can be selected within date range


function hasHalfYear(startDate, endDate, _ref2, _ref3) {
  var firstQuarter = _ref2.firstQuarter,
      firstYear = _ref2.firstYear;
  var secondQuarter = _ref3.secondQuarter,
      secondYear = _ref3.secondYear;
  return hasQuarter(startDate, endDate, firstQuarter, firstYear) && hasQuarter(startDate, endDate, secondQuarter, secondYear);
}

function hasRollingQuarter(startDate, endDate, month, year) {
  return (0, _some2.default)([0, 1, 2], function (monthsForward) {
    var selectedMonth = (0, _momentTimezone2.default)().year(year).month(month).date(1).add(monthsForward, 'months');
    return hasMonth(startDate, endDate, selectedMonth.month(), selectedMonth.year());
  });
} // checks if year can be selected within date range


function hasYear(startDate, endDate, year) {
  var startYear = (0, _momentTimezone2.default)(startDate).year();
  var endYear = (0, _momentTimezone2.default)(endDate).year();
  return year >= startYear && year <= endYear;
} // converts a date to a moment range


function fromDateToMomentRange(_ref4) {
  var quarter = _ref4.quarter,
      month = _ref4.month,
      halfyear = _ref4.halfyear,
      year = _ref4.year;
  var beginDate = void 0;
  var endDate = void 0;

  if (month !== undefined) {
    beginDate = (0, _momentTimezone2.default)({
      month: month,
      day: 1,
      year: year
    });
    endDate = beginDate.clone().add(1, 'months');
  } else if (quarter) {
    beginDate = (0, _momentTimezone2.default)({
      month: QUARTER_MONTHS[quarter],
      year: year,
      day: 1
    });
    endDate = beginDate.clone().add(3, 'months');
  } else if (halfyear !== undefined) {
    beginDate = (0, _momentTimezone2.default)({
      month: HALFYEAR_MONTHS[halfyear],
      year: year,
      day: 1
    });
    endDate = beginDate.clone().add(6, 'months');
  }

  return [beginDate, endDate];
}
/**
 * returns if a date or period is in a period (inclusive)
 *
 * @param {object} period - { start: '2016-12-01', end: '2017-12-01' }
 * @param {object} comparison - period { date: '2016-12-01', type: 'month' }
 * or date { quarter: undefined, month: 1, halfyear: undefined, quarter: undefined }
 * @returns {boolean}
 */


function isInPeriod(period, comparison) {
  if (period && period.date) {
    var _fromPeriodToMomentRa = fromPeriodToMomentRange(period),
        _fromPeriodToMomentRa2 = _slicedToArray(_fromPeriodToMomentRa, 2),
        beginDate = _fromPeriodToMomentRa2[0],
        endDate = _fromPeriodToMomentRa2[1];

    var _ref5 = comparison.date ? fromPeriodToMomentRange(comparison) : fromDateToMomentRange(comparison),
        _ref6 = _slicedToArray(_ref5, 2),
        comparisonBeginDate = _ref6[0],
        comparisonEndDate = _ref6[1];

    return period.type !== 't30' && comparisonBeginDate.isBetween(beginDate, endDate, null, '[)') && comparisonEndDate.isBetween(beginDate, endDate, null, '(]');
  }

  return false;
}
/**
 * returns if a period is a valid period in a range (inclusive)
 *
 * @param {object} range - { start: '2016-12-01', end: '2017-12-01' }
 * @param {object} period - { date: '2016-12-01', type: 'month' }
 * @returns {boolean}
 */


function isInRange(range, period) {
  if (range !== true) {
    var startDate = range.start,
        endDate = range.end;
    var periodDate = (0, _momentTimezone2.default)(period.date);

    if (period.type === 'day') {
      return hasDay(startDate, endDate, periodDate.month(), periodDate.year());
    } else if (period.type === 'week') {
      return hasWeek((0, _momentTimezone2.default)(startDate), (0, _momentTimezone2.default)(endDate), periodDate);
    } else if (period.type === 'month') {
      return hasMonth(startDate, endDate, periodDate.month(), periodDate.year());
    } else if (period.type === 'quarter') {
      return hasQuarter(startDate, endDate, periodDate.quarter(), periodDate.year());
    } else if (period.type === 'rollingQuarter') {
      return hasRollingQuarter(startDate, endDate, periodDate.month(), periodDate.year());
    } else if (period.type === 'halfyear') {
      return hasHalfYear(startDate, endDate, {
        firstQuarter: periodDate.quarter(),
        firstYear: periodDate.year()
      }, {
        secondQuarter: periodDate.clone().add(3, 'months').quarter(),
        secondYear: periodDate.clone().add(3, 'months').year()
      });
    } else if (period.type === 'year') {
      return hasYear(startDate, endDate, periodDate.year());
    }
  }

  return true;
} // converts a period into a display string used in the date input


function fromPeriodToDisplayString(period) {
  if (period) {
    var type = period.type,
        date = period.date;
    var selectedDate = (0, _momentTimezone2.default)(date);
    var periodToDisplay = {
      day: selectedDate.format('MMM D, YYYY'),
      month: selectedDate.format('MMM YYYY'),
      quarter: 'Q' + selectedDate.quarter() + ' ' + selectedDate.year(),
      halfyear: 'Q' + selectedDate.quarter() + ' - Q' + selectedDate.clone().add(3, 'months').quarter() + ' ' + selectedDate.clone().add(3, 'months').year(),
      t30: 'Last 30 Days',
      year: selectedDate.format('YYYY'),
      rollingQuarter: selectedDate.format('MMM YYYY') + ' - ' + selectedDate.clone().add(2, 'months').format('MMM YYYY'),
      week: 'Week of ' + selectedDate.format('MMM D, YYYY')
    };
    return periodToDisplay[type];
  }

  return '';
} // checks if a quarter is the start of a selected or hovered halfyear


function quarterIsStartOfHalfYear(period, quarter, year) {
  if (isInPeriod(period, {
    quarter: quarter,
    year: year
  })) {
    // if the quarter before it is in the period
    if (quarter !== 4) {
      return isInPeriod(period, {
        quarter: quarter + 1,
        year: year
      });
    } // if we need to wrap around to the previous year


    return isInPeriod(period, {
      quarter: 1,
      year: year + 1
    });
  }

  return false;
} // checks if a quarter is the end of a selected or hovered halfyear


function quarterIsEndOfHalfYear(period, quarter, year) {
  if (isInPeriod(period, {
    quarter: quarter,
    year: year
  })) {
    // if the quarter before it is in the period
    if (quarter !== 1) {
      return isInPeriod(period, {
        quarter: quarter - 1,
        year: year
      });
    } // if we need to wrap around to the previous year


    return isInPeriod(period, {
      quarter: 4,
      year: year - 1
    });
  }

  return false;
}
/**
 * Get an array of all days (moment objects) to show in calendar.
 * @param  {Number} month Month of the current year which is active in the calendar (moment().month())
 * @param  {Number} year
 * @return {Array}        Moment objects to show in calendar
 */


var getDaysForCalendar = exports.getDaysForCalendar = function getDaysForCalendar(month) {
  var year = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _momentTimezone2.default)().year();
  var adjustedMonth = void 0;
  var adjustedYear = void 0; // if month < 0 (ex. -1), it represents a month in the previous year (ex. last December)
  // and we need to adjust the month and year we use to compute startDay and endDay accordingly

  if (month < 0) {
    adjustedMonth = month + TOTAL_MONTHS;
    adjustedYear = year - 1;
  }

  var startDay = (0, _momentTimezone2.default)({
    year: adjustedYear || year,
    month: adjustedMonth || month
  }).startOf('month');
  var endDay = (0, _momentTimezone2.default)({
    year: adjustedYear || year,
    month: adjustedMonth || month
  }).endOf('month');

  var daysRange = _momentTimezone2.default.range(startDay, endDay);

  var days = Array.from(daysRange.by('days')) // filter out any months other than the current month and previous month
  .filter(function (day) {
    return day.month() + 1 - endDay.month() !== -2 && day.month() + 1 - endDay.month() !== 10;
  });
  return days;
};